<rt-empty-state
  [icon]="emptyState.icon"
  [title]="emptyState.header"
  [desc]="emptyState.description"
>
  @if (emptyState.button; as button) {
    <rt-button [variant]="'tertiary'" (click)="button.action(vcRef)">
      @if (button.iconName; as iconName) {
        <rt-icon [name]="iconName"></rt-icon>
      }
      {{ button.label }}
    </rt-button>
  }
</rt-empty-state>
